import { ExpiredLink as StyledExpiredLink } from './ExpiredLink.styles.js';

import Header from '../../components/Header';
import ExpiredLink from '../../components/ExpiredLink';

const ExpiredLinkPage = () => (
	<StyledExpiredLink>
		<Header />

		<ExpiredLink />
	</StyledExpiredLink>
);

export default ExpiredLinkPage;
